import { toast } from "react-toastify";
import { fetchCanvasSizes } from "../../../utils/truInkTemplate";

 export   const loadCanvasSizes = async (setIsLoadingSizes, setCanvasSizes, setFormData, setError, tenantId) => {
      if (!tenantId) {
        toast.error('Tenant ID not available for loading canvas sizes');
        return;
      }

      setIsLoadingSizes(true);
      try {
        const sizesData = await fetchCanvasSizes(tenantId);

        if (sizesData && Array.isArray(sizesData)) {
          setCanvasSizes(sizesData);

          if (sizesData.length > 0) {
            const defaultSize = sizesData.find(size => size.isDefault) || sizesData[0];
            if (defaultSize && defaultSize.resolution) {
              setFormData(prev => ({
                ...prev,
                screenSize: defaultSize.resolution
              }));
            }
          }
        }

      } catch (error) {
        console.error('Error loading canvas sizes:', error);
        setError(`Error loading canvas sizes`);
      } finally {
        setIsLoadingSizes(false);
      }
    };
